export const reducerTypes = {
    GET_USER: "reducer/GET_USER",
    GET_DEAL: "reducer/GET_DEAL",
    GET_REFILL: 'reducer/GET_REFILL',
    GET_MY_REFILLS: 'reducer/GET_MY_REFILLS',
    GET_CHECK_SYSTEM: 'reducer/GET_CHECK_SYSTEM',
    GET_UPDATE_HEADER_ALERT: 'reducer/GET_UPDATE_HEADER_ALERT',
    GET_TRANSFERS: 'reducer/GET_TRANSFERS',
    GET_TRANSFERS_TO_USER: 'reducer/GET_TRANSFERS_TO_USER',
    GET_DEAL_MESSAGES: 'reducer/GET_DEAL_MESSAGES',
    GET_ALL_USERS: 'reducer/GET_ALL_USERS',
    GET_ALL_DEALS: 'reducer/GET_ALL_DEALS',
    GET_ALL_REFILLS: 'reducer/GET_ALL_REFILLS',
    GET_ALL_TRANSFERS: 'reducer/GET_ALL_TRANSFERS',
    GET_ALL_TRANSFERS_TO_USER: 'reducer/GET_ALL_TRANSFERS_TO_USER',
    GET_FIX_SUM_SYSTEM_MESSAGE:'reducer/GET_FIX_SUM_SYSTEM_MESSAGE',
    GET_NAME_THE_SITE: 'reducer/GET_NAME_THE_SITE',
    GET_CRIPTO_WALLET: 'reducer/GET_CRIPTO_WALLET',
    GET_ADMIN_CHAT: 'reducer/GET_ADMIN_CHAT',
    GET_ADMIN_MESSAGE: 'reducer/GET_ADMIN_MESSAGE',
    GET_MESSAGE_TO_ADMIN: 'reducer/GET_MESSAGE_TO_ADMIN',
  };
  
  export const sagaTypes = {
    GET_USER: "saga/GET_USER",
  };
  